import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';
import { TableComponent } from '../../../table-component';
import { getAccreditationTableRows } from '../../constants';
import { CustomLoader } from '../../../custom-loader';

export const AccreditationContentView = ({ accreditationData, isAccreditationDataLoading, typeId, type }) => {
	if (isAccreditationDataLoading) {
		return <CustomLoader />;
	}

	return (
		<div className="accreditation-content">
			<>
				{accreditationData ? (
					<TableComponent
						isWithoutFooter
						isWithoutHeader
						isChildren
						columns={getAccreditationTableRows(type, typeId)}
						rows={accreditationData}
						isTableDataLoading={isAccreditationDataLoading}
						isWithoutTableHeader={!accreditationData.length}
					/>
				) : (
					<div className="accreditation-content__empty-message">Данные по аккредитации отсутствуют</div>
				)}
			</>
		</div>
	);
};

AccreditationContentView.propTypes = {
	accreditationData: PropTypes.string,
	isAccreditationDataLoading: PropTypes.bool.isRequired,
	typeId: PropTypes.array.isRequired,
	type: PropTypes.string,
};
